var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 120 40"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 40,
  rx: 6
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 60,
  y: 26,
  fill: "#FFF",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 18,
  fontWeight: "bold",
  textAnchor: "middle"
}, "TWINT")));
export { SvgTwint as ReactComponent };
export default __webpack_public_path__ + "Twint.c0273c79.svg";